import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const SalesTable = ({ showDetails, searchTerm }) => {
    const shiftSalesReport = useSelector(
        (state) => state.posReportshiftSlice.shiftReportSale);
    const decimalPosition = localStorage.getItem("decimalPosition");
    const [expandedRows, setExpandedRows] = useState({});

    const formatDate = (dateTimeString) => {
        return dateTimeString.split(' ')[0];
    };

    const toggleRow = (index) => {
        setExpandedRows((prev) => ({ ...prev, [index]: !prev[index] }));
    };

    const getOrderTax = (r) => {
        return Number(r.totalExclusive || 0) + Number(r.totalInclusive || 0);
    };

    const getItemTaxTotal = (item) => {
        return Math.abs(Number(item.lineTotal || 0) - Number(item.subTotalWoTax || 0));
    };

    const mainColCount = showDetails ? 11 : 10;

    const filteredSale = shiftSalesReport?.sale?.filter((r) => {
        if (!searchTerm) return true;
        const term = searchTerm.toLowerCase();
        if (r.name?.toLowerCase().includes(term)) return true;
        if (r.customerName?.toLowerCase().includes(term)) return true;
        if (r.mobileNo?.toLowerCase().includes(term)) return true;
        if (r.orderDate?.toLowerCase().includes(term)) return true;
        if (r.orderInfo?.some((item) => item.desccription?.toLowerCase().includes(term))) return true;
        return false;
    });

    return (
        <div className="new-global-table-container" style={{ paddingTop: "0 42px" }}>
            <table>
                <thead>
                    <tr>
                        {showDetails && <th style={{ width: "30px" }}></th>}
                        <th>Date</th>
                        <th>Order Reff</th>
                        <th>Customer</th>
                        <th>Mobile</th>
                        <th>Delivery Charge</th>
                        <th>Tax</th>
                        <th>Order Amount</th>
                        <th>Paid Amount</th>
                        <th>Balance</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredSale?.length > 0 ? filteredSale?.map((r, i) => (
                        <React.Fragment key={i}>
                            <tr
                                style={{
                                    backgroundColor: i % 2 === 0 ? "white" : "#e9e7e7",
                                    cursor: showDetails ? "pointer" : "default",
                                }}
                                onClick={() => showDetails && toggleRow(i)}
                            >
                                {showDetails && (
                                    <td style={{ border: "none", height: "29px", width: "30px", textAlign: "center" }}>
                                        {r.orderInfo?.length > 0 && (
                                            expandedRows[i]
                                                ? <KeyboardArrowUpIcon fontSize="small" />
                                                : <KeyboardArrowDownIcon fontSize="small" />
                                        )}
                                    </td>
                                )}
                                <td style={{ border: "none", height: "29px" }}>{formatDate(r.orderDate)}</td>
                                <td style={{ border: "none", height: "29px" }}>{r.name}</td>
                                <td style={{ border: "none", height: "29px" }}>{r.customerName}</td>
                                <td style={{ border: "none", height: "29px" }}>{r.mobileNo}</td>
                                <td style={{ border: "none", height: "29px" }}>{r.deliveryCharge}</td>
                                <td style={{ border: "none", height: "29px" }}>{getOrderTax(r).toFixed(decimalPosition)}</td>
                                <td style={{ border: "none", height: "29px" }}>{r.amtTotal}</td>
                                <td style={{ border: "none", height: "29px" }}>{r.paidAmt}</td>
                                <td style={{ border: "none", height: "29px" }}>{r.amountDue}</td>
                            </tr>
                            {showDetails && expandedRows[i] && r.orderInfo?.length > 0 && (
                                <tr>
                                    <td colSpan={mainColCount} style={{ padding: 0, border: "none" }}>
                                        <table style={{ width: "90%", margin: "4px auto 8px", borderCollapse: "collapse", tableLayout: "fixed" }}>
                                            <colgroup>
                                                <col style={{ width: "4%" }} />
                                                <col style={{ width: "22%" }} />
                                                <col style={{ width: "14%" }} />
                                                <col style={{ width: "14%" }} />
                                                <col style={{ width: "7%" }} />
                                                <col style={{ width: "12%" }} />
                                                <col style={{ width: "15%" }} />
                                                <col style={{ width: "12%" }} />
                                            </colgroup>
                                            <thead>
                                                <tr style={{ backgroundColor: "#f0eaff" }}>
                                                    <th style={{ padding: "4px 8px", fontSize: "12px", textAlign: "center" }}>#</th>
                                                    <th style={{ padding: "4px 8px", fontSize: "12px", textAlign: "left" }}>Item</th>
                                                    <th style={{ padding: "4px 8px", fontSize: "12px", textAlign: "left" }}>Category</th>
                                                    <th style={{ padding: "4px 8px", fontSize: "12px", textAlign: "left" }}>POS Category</th>
                                                    <th style={{ padding: "4px 8px", fontSize: "12px", textAlign: "center" }}>Qty</th>
                                                    <th style={{ padding: "4px 8px", fontSize: "12px", textAlign: "right" }}>Rate</th>
                                                    <th style={{ padding: "4px 8px", fontSize: "12px", textAlign: "right" }}>Tax</th>
                                                    <th style={{ padding: "4px 8px", fontSize: "12px", textAlign: "right" }}>Total</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {r.orderInfo.map((item, idx) => (
                                                    <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? "#faf9ff" : "#f3f1fa" }}>
                                                        <td style={{ padding: "3px 8px", fontSize: "12px", textAlign: "center" }}>{idx + 1}</td>
                                                        <td style={{ padding: "3px 8px", fontSize: "12px", textAlign: "left" }}>{item.desccription}</td>
                                                        <td style={{ padding: "3px 8px", fontSize: "12px", textAlign: "left" }}>{item.categoryName || "-"}</td>
                                                        <td style={{ padding: "3px 8px", fontSize: "12px", textAlign: "left" }}>{item.posCategoryName || "-"}</td>
                                                        <td style={{ padding: "3px 8px", fontSize: "12px", textAlign: "center" }}>{item.qty}</td>
                                                        <td style={{ padding: "3px 8px", fontSize: "12px", textAlign: "right" }}>{Number(item.unitPrice).toFixed(decimalPosition)}</td>
                                                        <td style={{ padding: "3px 8px", fontSize: "12px", textAlign: "right" }}>
                                                            {item.taxes?.length > 0
                                                                ? <>
                                                                    {item.taxes.map((t, ti) => (
                                                                        <div key={ti} style={{ fontSize: "10px", lineHeight: "1.3", color: "#666" }}>
                                                                            {t.taxName || 'Tax'} ({Number(t.amount || 0)}%)
                                                                        </div>
                                                                    ))}
                                                                    <div style={{ fontSize: "11px", fontWeight: "bold", borderTop: item.taxes.length > 1 ? "1px solid #ddd" : "none", marginTop: "1px" }}>
                                                                        {getItemTaxTotal(item).toFixed(decimalPosition)}
                                                                    </div>
                                                                </>
                                                                : "-"
                                                            }
                                                        </td>
                                                        <td style={{ padding: "3px 8px", fontSize: "12px", textAlign: "right" }}>{Number(item.lineTotal).toFixed(decimalPosition)}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            )}
                        </React.Fragment>
                    )) : (
                        <tr>
                            <td colSpan={mainColCount}>
                                NO DATA
                            </td>
                        </tr>
                    )}
                </tbody>
                <tfoot>
                    <tr style={{ backgroundColor: "rgb(150 148 148)" }}>
                        <td colSpan={showDetails ? 7 : 6} style={{ textAlignLast: "end", paddingInline: "10px" }}>TOTAL</td>
                        <td style={{ textAlignLast: "center" }}>{(filteredSale || []).reduce((acc, current) => acc + Number(current?.amtTotal || 0), 0)?.toFixed(decimalPosition)}</td>
                        <td style={{ textAlignLast: "center" }}>{(filteredSale || []).reduce((acc, current) => acc + Number(current?.paidAmt || 0), 0)?.toFixed(decimalPosition)}</td>
                        <td style={{ textAlignLast: "center" }}>{(filteredSale || []).reduce((acc, current) => acc + Number(current?.amountDue || 0), 0)?.toFixed(decimalPosition)}</td>
                    </tr>
                </tfoot>
            </table>
        </div>
    )
}

export default SalesTable